<template>
<!--     Loop through displayedPosts to display each post     -->
<section :class="{allslidescss: allslidestheme==='allslidescss'}">
  <div class="container seccarouselshow">
    <div v-for="(photo, index) in displayedPhotos" :key="index" :class="slideshowlk" class="slide-info"  data-aos="fade" data-aos-duration="2500">
      <div class="row carouselrow">
        <div class="col-sm-12 col-md-7 collarge">
          <!-- <div v-html="photo.slidedesc"  class="courselphotodesc">
          </div> -->
          <div v-html="photo.slidetext" id="vHTMLDiv" class="slidetext">
          </div>
               
          <span align="right"><router-link :to="{path: photo.slidelmorelink}" class="newslearnmore">{{ photo.slidelmoretext}}<i class="fa-brands fa-readme"></i></router-link></span>
          <p>{{ page}}/{{totalPages }}</p>
        </div>
        <div class="col-sm-12 col-md-5 colsmall carouselcol5">
          <img class="imgsize pulse seccarouselimage" :src="`${myPicUrl}${photo.slideimage}`" :key="photo.slideid" alt="">
          <div class="carousellinktextdiv card show">
            <div v-html="photo.slideimagetext" class="carousellinktext"></div>
          </div>
      </div>
    </div>
    <div class="format-buttons">
      <div class="clearfix btn-group">
        <button type="button" class="btn" v-if="page != 1" @click="page--"><i class="fa-solid fa-square-caret-left"></i></button>
        <button type="button" class="btn" v-for="pageNumber in pages" @click="page = pageNumber"> {{pageNumber}} </button>
        <button type="button" @click="page++" v-if="page < totalPages" class="btn"> <i class="fa-solid fa-square-caret-right"></i></button>
      </div>
    </div>
  </div>  
  </div>
</section>
</template>

<script>
import axios from 'axios';
require('@/globalDeclare.js');

export default {
  props: ['ophotos', 'page', 'perPage', 'pages', 'totalPages', 'displayedPhotos', 'slidertheme', 'allslidestheme'],
    data() {
        return {
          myPicUrl: '',
        }
    },
    mounted(){
      this.myPicUrl = myUrlPath
    },
    methods: {
        setPages () {
            let numberOfPages = Math.ceil(this.ophotos.length / this.perPage);
            
            for (let index = 1; index <= numberOfPages; index++) {
                this.pages.push(index);
            }
        },
        paginate (ophotos) {
            let page = this.page;
            let perPage = this.perPage;
            let from = (page * perPage) - perPage;
            let to = (page * perPage);
            return  ophotos.slice(from, to);
        },
    },
    computed: {
        displayedPhotos () {
            return this.paginate(this.ophotos);
        }
    },
    watch: {
        photos () {
            this.setPages();
        }
    },
  
}
</script>

<style scoped>
.seccarouselshow {
  padding: 30px;
}
.sectioncarouselslide {
  background-color: rgb(230, 234, 238);
}
.btn-lg, .fa-square-caret-left, .fa-square-caret-right {
  font-size: 68px;
  margin-top: -100px;
}
.newslearnmore{
  font-size: 20px;
  padding-right: 30px;
  color: orangered;
  text-decoration: none;
  padding-top: 30px;
}
.fa-readme {
  padding-left: 10px;
  color: orangered;
}
.slide-info {
  padding-top: 100px;
}
  /*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {
  .imgsize {
    width: 100%;
  }
  .newslearnmore {
    float: right;
  }
  .carousellinktextdiv {
    text-align: center;
    margin-bottom: 100px;
  }
 .format-buttons {
  margin-bottom: 100px;
 }
 }

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {
  .imgsize {
    width: 100%;
    padding-top: 30px;
  }
  .newslearnmore {
    float: right;
  }
  .carousellinktextdiv {
    text-align: center;
  }
 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {
  .imgsize {
    width: 100%;
    padding-top: 30px;
  }
  .collarge {
    width: 100%;
  }
  .colsmall {
    width: 100%;
    padding-top: 90px;
  }
  .col-md-5 {
    margin-top: -80px;
  }
  .carousellinktextdiv {
    width: 60%;
    margin-top: -26px;
    margin-left: -9px;
    padding: 10px;
  }
 }
 
 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {
  .carousellinktextdiv {
    width: 80%;
    margin-top: -26px;
    padding: 10px;
    text-align: left;
  }
  .collarge {
    width: 70%;
  }
  .colsmall {
    width: 30%;
    padding-top: 90px;
    margin-top: -170px;
  }
 }
 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {
  .seccarouselimage{
    width: 80%;
  }
  .collarge{
    width: 60%;
    padding-top: 50px;
    padding-right: 40px;
  }
  .colsmall{
    width: 40%;
  }
  .imgsize {
    height: 400px;
    width: 500px;
  }
 } 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1400px) {
  
  
 } 
</style>